module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAeCAYAAADKO/UvAAAA20lEQVRIS6XUsQ3CMBCF4f8GoaIEKRMwAnuQHraAHhiBkgVYAYldqJCMHJkoIXZ8Z19/n66494SCcc4tgTvwATZiNQLwABZhtzEhEeAoIgc1EgFOIrL316iQOUCF5IAsogFmES2QRCxAFLECE6QEGCGlQI/UAB1SC/yQF7AOYepf2RJMf8kTaMLSFdiJiLMiPtI+2r4j/JihLoDOuSqoT3ENNKqCUmjSJyVQtJSsULLZLNBsPUagC9D+/1G2YzVQFkn80egiFZKD1EgCOotIa0IS0MqMDKAb8Aa2X2r+oIOc2YwAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/back.png
// module id = akd5
// module chunks = 1